import { render } from "./LandingPageLink.vue?vue&type=template&id=5dad114a&scoped=true"
import script from "./LandingPageLink.vue?vue&type=script&lang=js"
export * from "./LandingPageLink.vue?vue&type=script&lang=js"

import "./LandingPageLink.vue?vue&type=style&index=0&id=5dad114a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dad114a"]])

export default __exports__